import React from 'react';
import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import ProductGrid from './components/ProductGrid';
import CartPage from './components/CartPage';

import './App.css';
import './gutenberg.css';

import Header from './components/sections/Header';
import Footer from './components/sections/Footer';

import Kosarica from './components/pages/Kosarica';
import Home from './components/pages/Home';
import Webshop from './components/pages/Webshop';
import Kontakt from './components/pages/Kontakt';
import Onama from './components/pages/Onama';
import Edukacije from './components/pages/Edukacije';

function App() {
  return (
    <CartProvider>
      <Router>
        <div className="App">
          <Header />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/kosarica" element={<Kosarica />} />
            <Route path="/webshop" element={<Webshop />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/ProductGrid" element={<ProductGrid />} />
            <Route path="/Onama" element={<Onama />} />
            <Route path="/Home" element={<Home />} />
           
            <Route path="/edukacije" element={<Edukacije />} />
            <Route path="/cart" element={<CartPage />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;




